// eslint-disable-next-line import/no-anonymous-default-export
export default {
  //live
  BASE_URL: "https://api.cars53.in/v1",
  IMAGE_URL: "https://api.cars53.in",
  //local
  // BASE_URL: "http://localhost:5500/v1",
  // IMAGE_URL: "http://localhost:5500",
  REACT_APP_RAZORPAY_KEY : "rzp_live_X9AC4dOucZtKRc",
  // Cars53 Partner support on WhatsApp (MSG91 business number)
  WHATSAPP_SUPPORT_NUMBER: "917566924753",
};
